import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import { Grid, Button, Typography, SwipeableDrawer, units } from '@ha/dsl';
import { PinBold, ArrowButtonDownBold } from '@ha/icons';
import { useTrackEvent } from 'ha/modules/Analytics/helpers/TrackEvent';

import { getCityName } from '../selectors';
import { SearchFiltersProvider } from '../SearchFiltersProvider';
import SearchBarContent from './SearchBarContent';

const useStyles = makeStyles(theme => ({
  pinIcon: {
    color: theme.palette.grey['500'],
    marginRight: '2px',
  },
  arrowIcon: {
    fontSize: units.rem(0.8),
    marginLeft: theme.spacing(1),
  },
  drawer: {
    padding: units.trbl(0.75, 1, 1, 1),
    borderRadius: '8px 8px 0px 0px',
  },
}));

const SearchBar: React.FC = () => {
  const classes = useStyles();

  const trackEvent = useTrackEvent();
  const cityName = useSelector(getCityName);

  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => {
    setOpen(true);

    trackEvent('Navbar location opened');
  }, [trackEvent]);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Grid container justify="center">
      <Button onClick={handleOpen}>
        <PinBold fontSize="inherit" className={classes.pinIcon} />
        <Typography.Paragraph textTransform="none">
          {cityName}
        </Typography.Paragraph>
        <ArrowButtonDownBold color="primary" className={classes.arrowIcon} />
      </Button>
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        disableSwipeToOpen
        onOpen={handleOpen}
        onClose={handleClose}
        PaperProps={{ className: classes.drawer }}
        SlideProps={{ unmountOnExit: true }}
      >
        <SearchFiltersProvider>
          <SearchBarContent onClose={handleClose} />
        </SearchFiltersProvider>
      </SwipeableDrawer>
    </Grid>
  );
};

export default SearchBar;
